/// <reference types="google.maps" preserve="true" />

import { ENVIRONMENT_TOKEN } from '@aksia/infrastructure';
import { Injectable, computed, effect, inject, resource } from '@angular/core';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  //#region Injections

  private environment = inject(ENVIRONMENT_TOKEN);

  //#endregion

  //#region Properties

  googleMapOptions = setOptions({
    key: this.environment.google_api_key,
    language: 'en',
  });

  googlePlaceApiResource = resource({
    loader: ({ params }) => importLibrary('places'),
  });
  googleMapApiResource = resource({
    loader: ({ params }) => importLibrary('maps'),
  });
  googleMarkerApiResource = resource({
    loader: ({ params }) => importLibrary('marker'),
  });

  placesAPI!: google.maps.PlacesLibrary;
  mapAPI!: google.maps.MapsLibrary;
  markerAPI!: google.maps.MarkerLibrary;

  locationServiceReady = computed(
    () =>
      !(
        this.googlePlaceApiResource.isLoading() &&
        this.googleMapApiResource.isLoading() &&
        this.googleMarkerApiResource.isLoading()
      ),
  );

  //#endregion

  constructor() {
    effect(() => {
      this.placesAPI = this.googlePlaceApiResource.value()!;
      this.mapAPI = this.googleMapApiResource.value()!;
      this.markerAPI = this.googleMarkerApiResource.value()!;
    });
  }
}
